// https://github.com/sindresorhus/escape-string-regexp
export const isMatching = (value: string | undefined, filterTerm: string) => {
    if (!value) {
        return false;
    }
    const regExp = new RegExp(
        filterTerm
            .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
            .replace(/-/g, '\\x2d'),
        'i'
    );

    return regExp.test(value);
};
